import React, { Component } from "react";
import { connect } from "react-redux";

import { enBrowserType } from "../../lib/ConstCommand";

import {
    clearPendingAutoOnAir,
    autoOnAirTimeout
} from "../../modules/live";

import LiveListTitleTemplate from "../../components/template/title/LiveListTitleTemplate";

import PerformStudioInfo from "../../components/studio/PerformStudioInfo";
import StudioList from "../../components/studio/StudioList";
import MyBroadcastLiveList from "../../components/live/MyBroadcastLiveList";
import WebMyBroadcastLiveList from "../../components/live/WebMyBroadcastLiveList";

// 260804 client 준비 신호가 장시간 오지 않으면 자동 시작을 중단하고 수동 ONAIR를 안내한다.
const AUTO_ONAIR_READY_TIMEOUT_MS = 10000;

class MyBroadcastLiveListContainer extends Component {

    state = {
        isUpdate : false
    }

    autoOnAirReadyTimer = null;

    // ★ 추가: 자동 ONAIR 감지 및 실행
    componentDidMount() {
        // 260804 마운트 전에 자동 ONAIR 대기 정보가 준비된 경우에도 즉시 감지한다.
        this._updateAutoOnAirState();
    }

    componentDidUpdate() {
        this._updateAutoOnAirState();
    }

    componentWillUnmount() {
        this._clearAutoOnAirReadyTimer();
    }

    _clearAutoOnAirReadyTimer = () => {
        if (this.autoOnAirReadyTimer !== null) {
            clearTimeout(this.autoOnAirReadyTimer);
            this.autoOnAirReadyTimer = null;
        }
    }

    _updateAutoOnAirState = () => {
        const { pendingAutoOnAirInfo, isMediaClientReady } = this.props;

        if (!pendingAutoOnAirInfo) {
            this._clearAutoOnAirReadyTimer();
            return;
        }

        if (isMediaClientReady) {
            this._clearAutoOnAirReadyTimer();
            this._checkAndFireAutoOnAir();
            return;
        }

        if (this.autoOnAirReadyTimer === null) {
            this.autoOnAirReadyTimer = setTimeout(() => {
                this.autoOnAirReadyTimer = null;

                // 260804 타임아웃 순간의 최신 Redux 상태를 확인해 성공 직후 오경보를 방지한다.
                if (this.props.pendingAutoOnAirInfo && !this.props.isMediaClientReady) {
                    console.warn("[MyBroadcastLiveListContainer] 자동 ONAIR client 준비 대기 시간 초과");
                    this.props.autoOnAirTimeout();
                }
            }, AUTO_ONAIR_READY_TIMEOUT_MS);
        }
    }

    /**
     * 로컬 로그인 시 선택한 클래스를 자동으로 ONAIR하는 메서드.
     *
     * 실행 조건:
     *   1. pendingAutoOnAirInfo가 null이 아님 (자동 ONAIR 대기 중)
     *   2. list_live에 실제 데이터가 있음 (빈 배열이 아님)
     *   3. media_soup client의 영상 소스 준비 완료 신호를 받음
     *
     * 위 세 조건이 모두 충족될 때 한 번만 실행되고,
     * clearPendingAutoOnAir()로 pendingAutoOnAirInfo를 null로 초기화하여
     * 이후 list_live 변경에도 재실행되지 않도록 막는다.
     * 
     * 260729 고정 지연 대신 client 준비 완료를 확인해 실제 ONAIR를 실행한다.
     */
    _checkAndFireAutoOnAir = () => {
        const { pendingAutoOnAirInfo, list_live, connectedStudioInfo, isMediaClientReady } = this.props;

        // 조건 1: 자동 ONAIR 대기 정보가 없으면 즉시 종료
        if (!pendingAutoOnAirInfo) return;

        // 조건 2: 빈 배열이면 아직 로딩 중 → 대기
        if (!list_live || list_live.length === 0) return;

        // 조건 3: client 장치 목록과 최종 영상 소스가 준비될 때까지 대기
        if (!isMediaClientReady) return;

        const { liveSeq, liveName } = pendingAutoOnAirInfo;

        // list_live에서 로그인 시 선택한 liveSeq와 일치하는 항목을 찾는다
        // String() 변환으로 타입 불일치(number vs string) 방어
        const targetLive = list_live.find(
            (live) => String(live.liveSeq) === String(liveSeq)
        );

        // ★ 먼저 초기화: 찾든 못 찾든 pendingAutoOnAirInfo를 null로 리셋
        // ★ 조건 충족이 확인된 시점에 즉시 초기화
        // → 타이머가 발화하기 전에 list_live가 다시 업데이트돼도 재진입하지 않음(중복 실행되지 않음)
        this.props.clearPendingAutoOnAir();

        if (!targetLive) {
            // 로그인 시 선택한 클래스가 list_live에 없는 경우
            // (서버에서 해당 라이브가 삭제됐거나 권한이 없는 상황)
            console.warn(
                `[MyBroadcastLiveListContainer] 자동 ONAIR 대상(liveSeq: ${liveSeq})을 list_live에서 찾지 못함. 자동 ONAIR 취소.`
            );
            return;
        }

        // connectedStudioInfo가 있으면 그 groupLimit을, 없으면 targetLive의 groupLimit 사용
        // BroadcastLiveListContainer의 onHandleOnAirLive와 동일한 groupLimit 결정 로직
        const groupLimit = (connectedStudioInfo !== null && connectedStudioInfo !== undefined)
            ? connectedStudioInfo.groupLimit
            : (targetLive.groupLimit !== null && targetLive.groupLimit !== undefined)
                ? targetLive.groupLimit
                : 0;

        console.log(
            `[MyBroadcastLiveListContainer] client 준비 완료 후 자동 ONAIR 실행 → liveSeq: ${targetLive.liveSeq}, liveName: ${targetLive.liveName}`
        );

        // 상위 BroadcastLiveListContainer의 handleSelectedFunc("ONAIR")를 호출
        // BroadcastLiveListContainer에서 onAirLive() dispatch + initializeTimer() 실행
        this.props.handleSelectedFunc({
            selectedFunc   : "ONAIR",
            liveSeq        : targetLive.liveSeq,
            liveName       : targetLive.liveName,
            groupLimit     : groupLimit,
            list_broadcast : targetLive.list_broadcast, // initializeTimer()에 필요
        });
    }

    render() {
        return (
            this.props.browserType === enBrowserType.HiClass ?
                <>
                    <LiveListTitleTemplate
                        isOnAirLive={this.props.isOnAirLive}
                        isOpenedHandsUp={this.props.isOpenedHandsUp}
                        isOpenedGroupStudy={this.props.isOpenedGroupStudy}
                        handleSelectedFunc={this.props.handleSelectedFunc}
                        selectedFunc={this.props.selectedFunc}
                    />
                    <div className="d-flex flex-column" style={{ height: '100%', minHeight: '50%' }}>
                        {
                            this.props.connectedStudioInfo === null ?
                                <StudioList
                                    userSeq={this.props.userSeq}
                                    list_studio={this.props.list_studio}
                                    list_live={this.props.list_live}
                                    handleSelectedFunc={this.props.handleSelectedFunc}
                                /> :
                                <PerformStudioInfo
                                    userSeq={this.props.userSeq}
                                    studio_info={this.props.connectedStudioInfo}
                                    list_live={this.props.list_live}
                                    handleSelectedFunc={this.props.handleSelectedFunc}
                                />
                        }
                        <MyBroadcastLiveList
                            isVisibleTitle={this.props.list_studio && this.props.list_studio.length > 0 ? true : false}
                            isShowing={this.props.isShowingBroadcastTimeNotify}
                            notifyInfo={this.props.notifyInfo}
                            list_live={this.props.list_live}
                            connectedStudioInfo={this.props.connectedStudioInfo}
                            serverUserSeq={this.props.serverUserSeq}
                            handleSelectedFunc={this.props.handleSelectedFunc}
                        />
                    </div>
                </> :
                <WebMyBroadcastLiveList
                    list_broadcastLive={this.props.list_live}
                    alertKind={this.props.alertKind}
                    alertMessage={this.props.alertMessage}
                    isCertifiedLiveCode={this.props.isCertifiedLiveCode}
                    isCreateLiveSuccess={this.props.isCreateLiveSuccess}
                    createdLiveCode={this.props.createdLiveCode}
                    searchLiveInfo={this.props.searchLiveInfo}
                    handleSelectedFunc={this.props.handleSelectedFunc}
                />
        );
    }
}

export default connect(
    ({ user, live, studio }) => ({
        userSeq                         : user.userSeq,
        serverUserSeq                   : user.serverUserSeq,

        isGotoWebLive                   : live.isGotoWebLive,
        performLiveSeq                  : live.performLiveInfo.liveSeq,

        list_live                       : live.list_live,
        isOnAirLive                     : live.isOnAirLive,

        createdLiveCode                 : live.web_createdLiveCode,
        isCertifiedLiveCode             : live.web_isCertifiedLiveCode,
        isCreateLiveSuccess             : live.web_isCreateLiveSuccess,

        isOpenedHandsUp                 : live.isOpenedHandsUp,
        isOpenedGroupStudy              : live.isOpenedGroupStudy,

        notifyInfo                      : live.notifyInfo,
        isShowingBroadcastTimeNotify    : live.isShowingBroadcastTimeNotify,

        searchLiveInfo                  : live.web_searchLiveInfo,

        alertKind                       : live.web_alertKind,
        alertMessage                    : live.web_alertMessage,

        pendingAutoOnAirInfo            : live.pendingAutoOnAirInfo,
        isMediaClientReady              : live.isMediaClientReady,
        selectedContentTeacher          : live.selectedContentTeacher,

        list_studio                     : studio.list_studio,
        connectedStudioInfo             : studio.connectedStudioInfo,
    }),
    {
        clearPendingAutoOnAir,
        autoOnAirTimeout,
    }
)(MyBroadcastLiveListContainer);
